import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserMyRadiant } from "@providers/index";

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  //url: string = 'http://172.24.3.7/app/api';
  // url: string = 'http://172.24.3.8/app/api';
  // url: string = 'http://192.168.1.202:88/api/api_erp';
  // url = "http://202.182.55.114:8011/radiant/erp/api/"
  // url: string = 'http://172.24.3.9/app/api';
  // url: string = 'http://202.182.55.114:8011/radiant/erp/api/';
  /*
   * ERP
   */
  // url: string = "http://erpmobile.appsradiant.com/app/api";

  /*
   * SPL
   */
  // url: string = "http://116.206.196.145/app/api";

  modul_selected = localStorage.getItem("approval_modul");
  url: string = "";

  constructor(public http: HttpClient, public userMyRadiant: UserMyRadiant) {
    this.modulCheck();
  }

  modulCheck() {
    this.modul_selected = localStorage.getItem("approval_modul");
    if(this.modul_selected == "spc") {
      this.url = "https://spc.appsradiant.com/app/api";
    }else if (this.modul_selected == "spl") {
      this.url = "https://spl.appsradiant.com/app/api";
    }else if (this.modul_selected == "rui") {
      this.url = "https://rui.appsradiant.com/app/api";
    }else if (this.modul_selected == "sdw") {
      this.url = "https://sdw.appsradiant.com/app/api";
    }
  }

  get(endpoint: string, params?: any, reqOpts?: any) {
    this.modulCheck();

    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }
    reqOpts.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    });
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(this.url + "/" + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    this.modulCheck();

    if (reqOpts == undefined) {
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    });
    let params = this.serialize(body);
    return this.http.post(this.url + "/" + endpoint, params, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    this.modulCheck();
    return this.http.put(this.url + "/" + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    this.modulCheck();
    return this.http.delete(this.url + "/" + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    this.modulCheck();
    return this.http.patch(this.url + "/" + endpoint, body, reqOpts);
  }

  serialize(obj) {
    var str = "";
    for (var key in obj) {
      if (str != "") {
        str += "&";
      }
      str += key + "=" + encodeURIComponent(obj[key]);
    }
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/providers/aproval_erp/api/api.ts